import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { LoginResponse } from '../../interfaces/login.interface';
import { catchError, from, map, Observable, switchMap, tap } from 'rxjs';
import { environment } from '../../../../environments/environment.prod';
import { encryptAuthTokenForStorage } from '../../utils/auth-token-storage.util';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private apiUrl = environment.apiUrl;
  private loginState = signal<boolean>(false);

  constructor(private http: HttpClient) {}

  isLoggedIn = computed(() => this.loginState());

  loginStateChange(isloginout: boolean): void {
    return this.loginState.set(isloginout);
  }

  login(email: string, password: string): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(this.apiUrl, { email, password }).pipe(
      switchMap((response) => {
        if (response.success && response.data?.token) {
          return from(encryptAuthTokenForStorage(response.data.token)).pipe(
            tap((encrypted) => localStorage.setItem('authToken', encrypted)),
            map(() => response),
          );
        }
        if (!response.success) {
          console.error('Login failed:', response.error);
        }
        return [response];
      }),
      catchError((error) => {
        return [{ success: false, error: error.message || 'Login failed' }];
      }),
    );
  }
}
